import { Button, withTheme } from '@material-ui/core';
import React from 'react';

function FancySelectButton(props) {
    const { highlight, children, label, theme, ...innerProps } = props;
    return (
        <Button
            variant="contained"
            className={`btn-golf-rounded${highlight ? '' : ' white'}`}
            color={highlight ? 'primary' : 'default'}
            {...innerProps}
        >
            {!label ? children : <span>{label}</span>}
        </Button>
    );
}

export default withTheme(FancySelectButton);
